var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "mx-1": "" } },
    [
      _c(
        "v-flex",
        { staticClass: "form-section", attrs: { xs12: "", md6: "" } },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "red--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text " }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.bmMeetingTitle)))
              ])
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isUpdate && _vm.meetingList.length
            ? _c("v-switch", {
                staticClass: "ml-1",
                attrs: {
                  color: "primary",
                  label: _vm.$t(_vm.lblSetting.bmCreateFromNextMeetingSwitch)
                },
                on: { change: _vm.changeSwitchCreateFromPreviousMeeting },
                model: {
                  value: _vm.coCreateFromPrevious,
                  callback: function($$v) {
                    _vm.coCreateFromPrevious = $$v
                  },
                  expression: "coCreateFromPrevious"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.coCreateFromPrevious
            ? _c(
                "v-layout",
                { staticClass: "mb-5", attrs: { column: "" } },
                [
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        xs4: "",
                        label: _vm.$t(_vm.lblSetting.bmPreviousMeeting)
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.meetingList,
                          label: _vm.$t(_vm.lblSetting.bmMeeting),
                          solo: "",
                          "item-text": "name",
                          "item-value": "id"
                        },
                        model: {
                          value: _vm.coLastMeetingId,
                          callback: function($$v) {
                            _vm.coLastMeetingId = $$v
                          },
                          expression: "coLastMeetingId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.bmMeeting.data &&
                  _vm.bmMeeting.data.inspections &&
                  _vm.bmMeeting.data.inspections.length
                    ? _c(
                        "base-control-label-vertical",
                        {
                          staticClass: "mb-3",
                          attrs: {
                            xs4: "",
                            label: _vm.$t(_vm.lblSetting.bmInspectionBundle)
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              staticStyle: { "margin-left": "0px" },
                              attrs: { row: "" }
                            },
                            _vm._l(_vm.bmMeeting.data.inspections, function(
                              ib
                            ) {
                              return _c("bm-ib_avatar", {
                                key: ib.id,
                                staticClass: "mr-2",
                                attrs: {
                                  src: ib.character_problem.picto,
                                  bgcolor: "#" + ib.color
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bmMeeting.data &&
                  _vm.bmMeeting.data.participants &&
                  _vm.bmMeeting.data.participants.length
                    ? _c(
                        "base-control-label-vertical",
                        {
                          attrs: {
                            xs4: "",
                            label: _vm.$t(_vm.lblSetting.bmMeetingParticipant)
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              staticStyle: { "margin-left": "0px" },
                              attrs: { row: "" }
                            },
                            _vm._l(_vm.bmMeeting.data.participants, function(
                              participant
                            ) {
                              return _c(
                                "v-avatar",
                                {
                                  key: participant.id,
                                  staticClass: "mr-2",
                                  attrs: { color: "primary", size: "32" }
                                },
                                [
                                  _vm.avatarLink(participant.entity)
                                    ? _c("img", {
                                        attrs: {
                                          src: _vm.avatarLink(
                                            participant.entity
                                          )
                                        }
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "white--text title" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.avatarText(
                                                  participant.entity
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              attrs: {
                required: "",
                xs4: "",
                label:
                  _vm.$t(_vm.lblSetting.agendaStart) +
                  " - " +
                  _vm.$t(_vm.lblSetting.agendaEnd)
              }
            },
            [
              _c("base-datetime-picker-range-vertical", {
                attrs: { step: _vm.dtStep, disableDate2: true },
                model: {
                  value: _vm.coDates,
                  callback: function($$v) {
                    _vm.coDates = $$v
                  },
                  expression: "coDates"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { "pl-3": "", xs12: "", md6: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("2")]),
                _vm._v(" "),
                _c("div", { staticClass: "red--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.bmNextMeetingTitle)))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-switch", {
            staticClass: "ml-1",
            attrs: {
              color: "primary",
              label: _vm.$t(_vm.lblSetting.bmNextMeetingSwitch)
            },
            model: {
              value: _vm.coSendNextMeeting,
              callback: function($$v) {
                _vm.coSendNextMeeting = $$v
              },
              expression: "coSendNextMeeting"
            }
          }),
          _vm._v(" "),
          _vm.coSendNextMeeting
            ? _c(
                "base-control-label-vertical",
                {
                  attrs: {
                    xs4: "",
                    label: "" + _vm.$t(_vm.lblSetting.bmNextMeetingLabel)
                  }
                },
                [
                  _c("base-datetime-picker-solo-vertical", {
                    attrs: {
                      step: _vm.dtStep,
                      disabled: _vm.nextMeetingDisabled
                    },
                    model: {
                      value: _vm.coDatesNextMeeting,
                      callback: function($$v) {
                        _vm.coDatesNextMeeting = $$v
                      },
                      expression: "coDatesNextMeeting"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36c026da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36c026da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/building-monitor/components/bm-meeting-modal-vertical/template.html
// module id = null
// module chunks = 